import { ProductCategoryAttributeDTO } from '@/api/dto/ProductCategoryAttributeDTO';
import { ProductCategoryAttribute } from '@/models/entities/ProductCategoryAttribute';
import { CrudModule, IModuleState } from './CrudModule';
import { EntityType } from '@/store/entityModules/types';
import { SearchQueryFilters } from '@/models/filters/SearchQueryFilters';
import { GetterTree } from 'vuex';

class ProductCategoryAttributesModule extends CrudModule<
  ProductCategoryAttribute,
  ProductCategoryAttributeDTO
> {
  state: IModuleState<ProductCategoryAttribute, ProductCategoryAttributeDTO> = {
    ...this.state,

    entityType: EntityType.PRODUCT_CATEGORY_ATTRIBUTE,
    queryFilters: new SearchQueryFilters({}),
  };

  getters: GetterTree<
    IModuleState<ProductCategoryAttribute, ProductCategoryAttributeDTO>,
    any
  > = {
    ...this.getters,

    getItem: state => (id: number) => {
      const item = state.items.find((i: ProductCategoryAttribute) => i.id === id);
      return item || null;
    },
  };
}

const productCategoryAttributesModule = new ProductCategoryAttributesModule();
export default productCategoryAttributesModule;
